import { IRootState } from '../../CorePackage/MainModule/interfaces/IRootState';

export const getErvkOrganisationsSearchQuery = (state: IRootState) =>
  state.changeKnoInPlan.ervkKnoOrganisationSearchQuery;
export const getKnoErvkOrganisations = (state: IRootState) => state.changeKnoInPlan.ervkKnoOrganisations;
export const getHistoryChangesItems = (state: IRootState) => state.changeKnoInPlan.historyChangesItems;
